/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import RcSlider, { SliderProps } from 'rc-slider'

const percentMarks = {
  0: '',
  25: '',
  50: '',
  75: '',
  100: '',
}

const dayMarks = {
  0: '',
  91.25: '',
  182.5: '',
  273.75: '',
  365: '',
}

interface ISliderProps extends SliderProps {
  id?: string
  max: number
  name?: string
  onChangeNameValue?: (name: any, value: number) => void
  type?: 'colored'
  value: number
  valueOnHandle?: boolean
  withPercentMarks?: boolean
}

export default class Slider extends React.Component<ISliderProps> {
  static defaultProps = {
    valueOnHandle: false,
    withPercentMarks: false,
  }

  constructor(props: any) {
    super(props)
    this.onChange = this.onChange.bind(this)
  }

  /**
   * Handle the native onChange event.
   */
  onChange(value: number) {
    if (this.props.onChange) {
      this.props.onChange(value)
    } else if (this.props.onChangeNameValue && this.props.name) {
      this.props.onChangeNameValue(this.props.name, value)
    }
  }
  render() {
    const {
      onChangeNameValue,
      onChange,
      valueOnHandle,
      withPercentMarks,
      className,
      type,
      ...otherProps
    } = this.props
    const percentSlider = this.props.value / this.props.max
    let cssClass = type === 'colored' ? 'colored-slider' : 'ooki-slider'
    const cssClassMark =
      type === 'colored'
        ? percentSlider < 1 / 3
          ? 'slider--first-third'
          : percentSlider < 2 / 3
          ? 'slider--second-third'
          : 'slider--third-third'
        : ''
    const rcSliderProps: any = {}
    valueOnHandle && (cssClass += ' value-on-handle')
    className && (cssClass += ` ${className}`)
    if (withPercentMarks && typeof this.props.max === 'number') {
      rcSliderProps.marks = {
        [this.props.max / 4]: '',
        [this.props.max / 2]: '',
        [(this.props.max / 4) * 3]: '',
        [this.props.max]: '',
      }
      cssClass += ' with-percent-marks'
    }

    return (
      <RcSlider
        className={cssClass + ' ' + cssClassMark}
        onChange={this.onChange}
        {...otherProps}
        {...rcSliderProps}
      />
    )
  }
}
